export default __webpack_public_path__ + "static/media/Ies_panel_AntonioGarza.64aca517.png";